import React, { useEffect, useState } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import {
  updateFooter,
  updateImage,
} from "../../../redux/actions/addCampaigndata";
import { Add } from "@mui/icons-material";
import { Box, Button, Grid, MenuItem, Paper, TextField, Toolbar, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { Col, Row } from "react-bootstrap";
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import StarRateIcon from '@mui/icons-material/StarRate';
import DeleteIcon from "@mui/icons-material/Delete";
import { motion } from "framer-motion";


const logoSchema = yup.array().of(
  yup.object().shape({
    file: yup.mixed().test("fileFormat", "Unsupported file format", (value) => {
      if (!value || !value.file) {
        return true;
      } else if (value || !value.file) {
        return true;
      }
      const file = value.file;
      const fileExtension = file?.name?.split(".").pop().toLowerCase();
      const supportedFormats = ["jpeg", "jpg", "png", "gif", "bmp", "svg", "webp"];
      return supportedFormats.includes(fileExtension);
    }),
    link: yup.string().nullable(),
    target: yup.string(),
    order: yup.number().notRequired(),
    alt: yup.string(),
  })
);

const common = yup
  .array()
  .of(
    yup.object().shape({
      link: yup.string(),
      target: yup.string(),
      order: yup.number().notRequired(),
      text: yup.string(),
    })
  )
  .notRequired();

const customerSupport = yup
  .array()
  .of(
    yup.object().shape({
      text: yup.string(),
      value: yup.string(),
      order: yup.number().notRequired(),
      link: yup.string(),
    })
  )
  .notRequired();

const footerImage = yup
  .object()
  .shape({
    file: yup.mixed().test("fileFormat", "Unsupported file format", (value) => {
      if (!value || !value.file) {
        return true;
      }
      const file = value.file;
      const fileExtension = file.name.split(".").pop().toLowerCase();
      const supportedFormats = ["jpeg", "jpg", "png", "gif", "bmp", "svg", "webp"];
      return supportedFormats.includes(fileExtension);
    }),
    link: yup.string(),
  })
  .notRequired();

const schema = yup.object().shape({
  footer_logo: footerImage,
  social_media: logoSchema,
  customer_support: customerSupport,
  brand_partners: common,
  quick_links: common,
  bank_partners: common,
  footer_images: logoSchema,
  // campaignId: yup.string().required("Campaign ID is required"),
  // uiType: yup.string().required("UI Type is required"),
  copy_right: yup.string(),
  // footer_logo: null,
}).notRequired();

const UpdateFooter = (props) => {
  const { activeStep } = props;
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const selector = useSelector((state) => state.addCampaignReducer);


  const handleBack = () => {
    navigate("/view-campaign");
  };

  //for all data show
  const data = useSelector((state) => state.addCampaignReducer.dataAll);
  const campaignId = selector?.dataAll?.campaign_Id || localStorage.getItem("campaign_id")
  const uiType = selector?.dataAll?.ui_type || localStorage.getItem("uitype")

  const [footerImages] = useState(data?.footer_logo.logo);
  const [socialImage] = useState(() =>
    data?.social_media.map((item) => item.logo)
  );
  const [footerImageBottom] = useState(() =>
    data?.footer_images.map((item) => item.logo)
  );


  // collapse state
  const [columnVisibility, setColumnVisibility] = useState({
    footer_logo: false,
    customer_support: false,
    brand_partners: false,
    social_media: false,
    quick_links: false,
    bank_partners: false,
    footer_images: false,
  });

  const toggleColumn = (columnName) => {
    setColumnVisibility({
      ...columnVisibility,
      [columnName]: !columnVisibility[columnName],
    });
  };



  const dispatch = useDispatch();
  const {
    control,
    handleSubmit,
    formState: { errors },
    register,
    clearErrors,
    setError,
    setValue,
    watch,
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),

    defaultValues: {
      footer_logo: { file: footerImages, link: "" },
      social_media: [{ file: socialImage, target: "", link: "", alt: "", order: "" }],
      customer_support: [{ text: "", value: "", order: "", link: "" }],
      brand_partners: [{ text: "", link: "", order: "", target: "" }],
      bank_partners: [{ text: "", link: "", order: "", target: "" }],
      quick_links: [{ text: "", link: "", order: "", target: "" }],
      footer_images: [{ file: footerImageBottom, target: "", link: "", alt: "", order: "" }],
      uiType: "",
      campaignId: "",
      copy_right: "",
      deleteUrl: [],
    },
  });

  const {
    fields: photoFields,
    append: appendPhoto,
    remove: removePhoto,
  } = useFieldArray({
    control,
    name: "footer_images",
  });
  const {
    fields: brandPartners,
    append: appendbrandPartners,
    remove: removebrandPartners,
  } = useFieldArray({
    control,
    name: "brand_partners",
  });

  const {
    fields: bankPartners,
    append: appendbankPartners,
    remove: removebankPartners,
  } = useFieldArray({
    control,
    name: "bank_partners",
  });

  const {
    fields: customerSupport,
    append: appendcustomerSupport,
    remove: removecustomerSupport,
  } = useFieldArray({
    control,
    name: "customer_support",
  });
  const {
    fields: quickLinks,
    append: appendquickLinks,
    remove: removequickLinks,
  } = useFieldArray({
    control,
    name: "quick_links",
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "social_media",
  });

  const user = localStorage.getItem("userID");



  const handleImage = async (index, logo, e) => {
    const file = e.target.files[0];

    const isImage = file && file.type.startsWith("image/");
    const formData = new FormData();
    formData.append("image", file);

    if (logo === "footer_logo") {
      clearErrors(`footer_logo.file`);
      if (!isImage) {
        setError(`footer_logo.file`, {
          type: "manual",
          message: "Invalid file type. Please select a valid image.",
        });
      } else {
        formData.append("link", logo && footerImage);
        formData.append("deleted_by", user);
        dispatch(updateImage(formData)).then((res) => {
          setValue(`footer_logo.logo`, res);
          setValue(`footer_logo.file`, res);
        });
      }
      // social_media
    } else if (logo === "social_media") {
      clearErrors(`social_media[${index}].file`);
      if (!isImage) {
        setError(`social_media[${index}].file`, {
          type: "manual",
          message: "Invalid file type. Please select a valid image.",
        });
      } else {
        formData.append("deleted_by", user);
        formData.append("link", logo && socialImage[index]);
        dispatch(updateImage(formData)).then((res) => {
          setValue(`social_media[${index}].file`, res);
          setValue(`social_media[${index}].logo`, res);
        });
      }
    } else {
      clearErrors(`footer_images[${index}].file`);
      if (!isImage) {
        setError(`footer_images[${index}].file`, {
          type: "manual",
          message: "Invalid file type. Please select a valid image.",
        });
      } else {
        formData.append("link", logo && footerImageBottom[index]);
        formData.append("deleted_by", user);
        dispatch(updateImage(formData)).then((res) => {
          setValue(`footer_images[${index}].image`, res);
          setValue(`footer_images[${index}].file`, res);
        });
      }
    }
  };



  const onSubmit = async (data) => {
    const { file: footerNewLogo, ...footer } = data?.footer_logo ?? "";
    data.footer_logo = footer;

    const recreatedSocialArray = data?.social_media?.map((item) => {
      const { file, ...newItem } = item;
      return newItem;
    });
    const recreatedFooterArray = data?.footer_images?.map((item) => {
      const { file, ...newItem } = item;
      return newItem;
    });
    const { uiType, campaignId, brand_partners, bank_partners, ...newData } = data;
    const checkBrand = !brand_partners && !brand_partners?.[0]?.link ? false : true;
    const checkBank = !bank_partners && !bank_partners?.[0]?.link ? false : true;


    const recreatedData = {
      ...newData,
      ...(checkBrand ? { brand_partners: brand_partners } : {}),
      ...(checkBank ? { bank_partners: bank_partners } : {}),
      campaign_Id: campaignId,
      ui_type: uiType,
      social_media: recreatedSocialArray,
      footer_images: recreatedFooterArray,
      deleteUrl: [],
      updated_by: user,
    };

    setIsLoading(true);
    const result = await dispatch(updateFooter(recreatedData));
    if (result?.success === true) {
      setTimeout(() => {
        setIsLoading(false);
        handleBack();
      }, 1000);
    } else if (!result) {
      handleBack();
    }
  };

  console.log(errors, "errors  ")

  useEffect(() => {
    if (data) {
      setValue("footer_logo", data?.footer_logo);
      setValue("social_media", data?.social_media);
      data?.social_media?.map((socialMedia, index) => setValue(`social_media[${index}].file`, socialMedia?.logo))
      setValue("customer_support", data?.customer_support);
      setValue("brand_partners", data?.brand_partners);
      setValue("bank_partners", data?.bank_partners);
      setValue("quick_links", data?.quick_links);
      setValue("footer_images", data?.footer_images);
      data?.footer_images?.map((footerImage, index) => setValue(`footer_images[${index}].file`, footerImage?.image))
      setValue("copy_right", data?.copy_right);
      setValue("campaignId", data?.campaign_Id);
      setValue("uiType", data?.ui_type);
    }
  }, [data]);

  useEffect(() => {
    if (uiType !== null && uiType !== undefined) {
      setValue("uiType", uiType);
    }
    if (campaignId !== null && campaignId !== undefined) {
      setValue("campaignId", campaignId);
    }
  }, [uiType, campaignId]);


  const handleUrlChange = (index, logo, e) => {
    const urlValue = e.target.value.trim();
    if (logo === "footer_logo" || logo === "social_media") {
      clearErrors(`${logo}[${index}].file`);
      setValue(`${logo}[${index}].logo`, urlValue);
      setValue(`${logo}[${index}].file`, urlValue);
    } else if (logo === "footer_images") {
      clearErrors(`${logo}[${index}].file`);
      setValue(`${logo}[${index}].image`, urlValue);
      setValue(`${logo}[${index}].file`, urlValue);
    }
  };

  return (
    <Box
      sx={{
        width: "98%",
      }}
    >
      <Paper elevation={3} sx={{ padding: "1.5rem" }}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            className="text-center fw-bold mb-3 border-bottom border-2 border-info pb-1"
            style={{ fontSize: "20px", color: "rgba(0, 165, 162, 0.9)" }}
          >
            Update Your Footer Section
          </motion.div>
          <div className="container">
            <Row>
              <Col lg={6}>
                <div className="text-success text-start fw-bold mb-3 buttons rounded-2" style={{ cursor: "pointer" }} onClick={() => toggleColumn('footer_logo')}>
                  Update Footer Logo <StarRateIcon />  {columnVisibility.footer_logo ? <span><ExpandLessIcon /></span> : <span><ExpandMoreIcon /></span>}
                </div>
                <div className="column" style={{ display: columnVisibility.footer_logo ? 'block' : 'none' }}>
                  <div className="d-flex justify-content-around mb-3 mt-2">
                    <Button
                      variant="contained"
                      component="label"
                      {...register(`footer_logo.file`)}
                      onClick={() => clearErrors(`footer_logo.file`)} // Clear errors for URL when file input is clicked
                    >
                      Upload Logo
                      <input
                        type="file"
                        {...register(`footer_logo.file`)}
                        hidden
                        onChange={(e) => handleImage(0, "footer_logo", e)}
                        className={`file_button mb-1 ${errors.footer_logo && errors?.footer_logo?.file ? "error" : ""}`}
                      />
                    </Button>
                    {watch(`footer_logo.logo`) && (
                      <div className="image_div bg-dark">
                        <img
                          src={watch(`footer_logo.logo`)}
                          alt=""
                          width={100}
                          height="auto"
                          className="rounded image "
                        />
                      </div>
                    )}

                  </div>
                  <Controller
                    name={`footer_logo.file`}
                    control={control}
                    render={({ field }) => (
                      <TextField
                        // required
                        {...field}
                        label="Update Footer Logo Url"
                        className={`w-100 mt-2 ${errors.footer_logo && errors?.footer_logo.file
                          ? "error"
                          : ""
                          }`}
                      />
                    )}
                  />
                  <Controller
                    name={`footer_logo.link`}
                    control={control}
                    render={({ field }) => (
                      <TextField
                        // required
                        {...field}
                        label="Footer Logo Link"
                        className={`w-100 mt-2 ${errors.footer_logo && errors?.footer_logo.link
                          ? "error"
                          : ""
                          }`}
                      />
                    )}
                  />
                </div>
                <hr />
              </Col>
              <Col lg={6}>
                <div className="text-success fw-bold mb-3 buttons rounded-2" style={{ cursor: "pointer" }} onClick={() => toggleColumn('social_media')}>
                  Update Social Media <StarRateIcon />  {columnVisibility.social_media ? <span><ExpandLessIcon /></span> : <span><ExpandMoreIcon /></span>}
                </div>
                <div style={{ display: columnVisibility.social_media ? 'block' : 'none' }}>
                  {fields.map((item, index) => (
                    <div key={item.id} className="form-row ">
                      <div className="column">
                        <div className="d-flex justify-content-around mb-3 mt-2">
                          <Button
                            variant="contained"
                            component="label"
                            {...register(`social_media[${index}].file`)}
                            onClick={() => clearErrors(`social_media[${index}].file`)} // Clear errors for URL when file input is clicked
                          >
                            Upload Image
                            <input
                              type="file"
                              {...register(`social_media[${index}].file`)}
                              hidden
                              onChange={(e) => handleImage(index, "social_media", e)}
                              className={`form-control mb-2 ${errors.social_media &&
                                errors?.social_media[index]?.image
                                ? "error"
                                : ""
                                }`}
                            />
                          </Button>
                          {watch(`social_media[${index}].logo`) && (
                            <div className="image_div">
                              <img
                                src={watch(`social_media[${index}].logo`)}
                                alt=""
                                width={100}
                                height="auto"
                                className="rounded image"
                              />
                            </div>
                          )}
                        </div>
                      </div>
                      <Controller
                        name={`social_media[${index}].file`}
                        control={control}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            label="Enter Link Image Url"
                            className={`form-control mb-2 ${errors.social_media &&
                              errors?.social_media[index]?.file
                              ? "error"
                              : ""
                              }`}
                            onChange={(e) => handleUrlChange(index, "social_media", e)}
                          />
                        )}
                      />
                      <div className="column">
                        <Controller
                          name={`social_media[${index}].link`}
                          control={control}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              label="Enter Link"
                              className={`form-control mb-2 ${errors.social_media &&
                                errors?.social_media[index]?.link
                                ? "error"
                                : ""
                                }`}
                            />
                          )}
                        />
                      </div>
                      <div className="d-flex gap-3">
                        <Controller
                          name={`social_media[${index}].target`}
                          control={control}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              select
                              label="Enter Target"
                              className={`form-control mb-2 ${errors.social_media &&
                                errors?.social_media[index]?.target
                                ? "error"
                                : ""
                                }`}
                            >
                              <MenuItem value="_self">_self</MenuItem>
                              <MenuItem value="_blank">_blank</MenuItem>
                            </TextField>
                          )}
                        />
                        <Controller
                          name={`social_media[${index}].order`}
                          control={control}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              select
                              label="Enter Order"
                              className={`form-control mb-2 ${errors.social_media &&
                                errors?.social_media[index]?.order
                                ? "error"
                                : ""
                                }`}
                            >
                              {[...Array(15).keys()].map((number) => (
                                <MenuItem
                                  key={number + 1}
                                  value={(number + 1).toString()}
                                >
                                  {number + 1}
                                </MenuItem>
                              ))}
                            </TextField>
                          )}
                        />
                      </div>

                      <div className="column">
                        <Controller
                          name={`social_media[${index}].alt`}
                          control={control}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              label="Enter Alt"
                              className={`form-control mb-2 ${errors.social_media &&
                                errors?.social_media[index]?.alt
                                ? "error"
                                : ""
                                }`}
                            />
                          )}
                        />
                      </div>
                      <div className="column d-flex justify-content-end">
                        {fields.length > 1 &&
                          <Tooltip title="Delete" arrow>
                            <DeleteIcon onClick={() => remove(index)} style={{ color: "red", cursor: "pointer" }} />
                          </Tooltip>
                        }
                      </div>
                    </div>
                  ))}
                  <div className="form-row mb-2">
                    <Grid className="d-flex justify-content-between">
                      <Tooltip title="Add" arrow>
                        <Button
                          className="button "
                          variant="outlined"
                          disableElevation
                          startIcon={<Add />}
                          onClick={() =>
                            append({
                              file: null,
                              link: "",
                              target: "",
                              order: "",
                              alt: "",
                            })
                          }
                        >
                          Add
                        </Button>
                      </Tooltip>
                    </Grid>
                  </div>
                </div>
                <hr />
              </Col>
            </Row>

            {/* ----------------------customer support  */}
            <Row>
              <Col lg={6}>
                <div>
                  <div className="text-success fw-bold mb-3 text-center buttons rounded-2" style={{ cursor: "pointer" }} onClick={() => toggleColumn('customer_support')}>
                    Update Customer Support <StarRateIcon /> {columnVisibility.customer_support ? <span><ExpandLessIcon /></span> : <span><ExpandMoreIcon /></span>}
                  </div>
                  <div style={{ display: columnVisibility.customer_support ? 'block' : 'none' }}>
                    {customerSupport.map((item, index) => (
                      <div key={item.id} className="form-row ">
                        <div className="column d-flex gap-3">
                          <Controller
                            name={`customer_support[${index}].text`}
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                label="Enter Text"
                                className={`form-control mb-3 ${errors.customer_support &&
                                  errors?.customer_support[index]?.text
                                  ? "error"
                                  : ""
                                  }`}
                              />
                            )}
                          />
                          <Controller
                            name={`customer_support[${index}].order`}
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                label="Enter Order"
                                select
                                className={`form-control mb-3 ${errors.customer_support &&
                                  errors?.customer_support[index]?.order
                                  ? "error"
                                  : ""
                                  }`}
                              >
                                {[...Array(10).keys()].map((number) => (
                                  <MenuItem
                                    key={number + 1}
                                    value={(number + 1).toString()}
                                  >
                                    {number + 1}
                                  </MenuItem>
                                ))}
                              </TextField>
                            )}
                          />
                        </div>
                        <div className="column">
                          <Controller
                            name={`customer_support[${index}].value`}
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                label="Enter Value"
                                className={`form-control mb-3 ${errors.customer_support &&
                                  errors?.customer_support[index]?.value
                                  ? "error"
                                  : ""
                                  }`}
                              />
                            )}
                          />
                        </div>

                        <div className="column">
                          <Controller
                            name={`customer_support[${index}].link`}
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                label="Enter Link"
                                className={`form-control mb-3 ${errors.customer_support &&
                                  errors?.customer_support[index]?.link
                                  ? "error"
                                  : ""
                                  }`}
                              />
                            )}
                          />
                        </div>
                        <div className="column d-flex justify-content-end">
                          {customerSupport.length > 1 &&
                            <Tooltip title="Delete" arrow>
                              <DeleteIcon onClick={() => removecustomerSupport(index)} style={{ color: "red", cursor: "pointer" }} />
                            </Tooltip>
                          }
                        </div>
                      </div>
                    ))}
                    <div className="form-row  mb-2">
                      <Grid className="d-flex justify-content-between">
                        <Tooltip title="Add" arrow>
                          <Button
                            className="button "
                            variant="outlined"
                            disableElevation
                            startIcon={<Add />}
                            onClick={() =>
                              appendcustomerSupport({
                                text: "",
                                value: "",
                                order: "",
                              })
                            }
                          >
                            Add
                          </Button>
                        </Tooltip>

                      </Grid>
                    </div>
                  </div>
                  <hr />
                </div>
              </Col>
              <Col lg={6}>
                <div className="text-success fw-bold mb-3 text-center buttons rounded-2" style={{ cursor: "pointer" }} onClick={() => toggleColumn('brand_partners')}>
                  Update Brand Partners  {columnVisibility.brand_partners ? <span><ExpandLessIcon /></span> : <span><ExpandMoreIcon /></span>}
                </div>
                <div style={{ display: columnVisibility.brand_partners ? 'block' : 'none' }}>
                  {brandPartners.map((item, index) => (
                    <div key={item.id} className="form-row ">
                      <div className="column">
                        <Controller
                          name={`brand_partners[${index}].text`}
                          control={control}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              label="Enter Text"
                              className={`form-control mb-2 ${errors.brand_partners &&
                                errors?.brand_partners[index]?.text
                                ? "error"
                                : ""
                                }`}
                            />
                          )}
                        />
                      </div>

                      <div className="column">
                        <Controller
                          name={`brand_partners[${index}].link`}
                          control={control}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              label="Enter Link"
                              className={`form-control mb-2 ${errors.brand_partners &&
                                errors?.brand_partners[index]?.link
                                ? "error"
                                : ""
                                }`}
                            />
                          )}
                        />
                      </div>
                      <div className="column d-flex gap-3">
                        <Controller
                          name={`brand_partners[${index}].target`}
                          control={control}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              label="Enter Target"
                              select
                              className={`form-control mb-2 ${errors.brand_partners &&
                                errors?.brand_partners[index]?.target
                                ? "error"
                                : ""
                                }`}
                            >
                              <MenuItem value="_self">_self</MenuItem>
                              <MenuItem value="_blank">_blank</MenuItem>
                            </TextField>
                          )}
                        />
                        <Controller
                          name={`brand_partners[${index}].order`}
                          control={control}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              label="Enter Order"
                              select
                              className={`form-control mb-2 ${errors.brand_partners &&
                                errors?.brand_partners[index]?.order
                                ? "error"
                                : ""
                                }`}
                            >
                              {[...Array(15).keys()].map((number) => (
                                <MenuItem
                                  key={number + 1}
                                  value={(number + 1).toString()}
                                >
                                  {number + 1}
                                </MenuItem>
                              ))}
                            </TextField>
                          )}
                        />
                      </div>
                      <div className="column d-flex justify-content-end">
                        {brandPartners.length > 1 &&
                          <Tooltip title="Delete" arrow>
                            <DeleteIcon onClick={() => removebrandPartners(index)} style={{ color: "red", cursor: "pointer" }} />
                          </Tooltip>
                        }
                      </div>
                    </div>
                  ))}
                  <div className="form-row  mb-2">
                    <Grid className="d-flex justify-content-between">
                      <Tooltip title="Add" arrow>
                        <Button
                          className="button "
                          variant="outlined"
                          disableElevation
                          startIcon={<Add />}
                          onClick={() =>
                            appendbrandPartners({
                              link: "",
                              target: "",
                              order: "",
                              text: "",
                            })
                          }
                        >
                          Add
                        </Button>
                      </Tooltip>
                    </Grid>
                  </div>
                </div>
                <hr />
              </Col>
            </Row>
            <Row className="mt-2">
              <Col lg={6}>
                <div className="text-success buttons rounded-2 fw-bold mb-3 mt-3" style={{ cursor: "pointer" }} onClick={() => toggleColumn('bank_partners')}>
                  Update Bank Partners  {columnVisibility.bank_partners ? <span><ExpandLessIcon /></span> : <span><ExpandMoreIcon /></span>}
                </div>
                <div style={{ display: columnVisibility.bank_partners ? 'block' : 'none' }}>
                  {bankPartners.map((item, index) => (
                    <div key={item.id} className="form-row ">
                      <div className="column">
                        <Controller
                          name={`bank_partners[${index}].text`}
                          control={control}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              label="Enter Text"
                              className={`form-control mb-2 ${errors.bank_partners &&
                                errors?.bank_partners[index]?.text
                                ? "error"
                                : ""
                                }`}
                            />
                          )}
                        />
                      </div>

                      <div className="column">
                        <Controller
                          name={`bank_partners[${index}].link`}
                          control={control}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              label="Enter Link"
                              className={`form-control mb-2 ${errors.bank_partners &&
                                errors?.bank_partners[index]?.link
                                ? "error"
                                : ""
                                }`}
                            />
                          )}
                        />
                      </div>
                      <div className="column d-flex gap-3">
                        <Controller
                          name={`bank_partners[${index}].target`}
                          control={control}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              label="Enter Target"
                              select
                              className={`form-control mb-2 ${errors.bank_partners &&
                                errors?.bank_partners[index]?.target
                                ? "error"
                                : ""
                                }`}
                            >
                              <MenuItem value="_self">_self</MenuItem>
                              <MenuItem value="_blank">_blank</MenuItem>
                            </TextField>
                          )}
                        />
                        <Controller
                          name={`bank_partners[${index}].order`}
                          control={control}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              label="Enter Order"
                              select
                              className={`form-control mb-2 ${errors.bank_partners &&
                                errors?.bank_partners[index]?.order
                                ? "error"
                                : ""
                                }`}
                            >
                              {[...Array(15).keys()].map((number) => (
                                <MenuItem
                                  key={number + 1}
                                  value={(number + 1).toString()}
                                >
                                  {number + 1}
                                </MenuItem>
                              ))}
                            </TextField>
                          )}
                        />
                      </div>
                      <div className="column d-flex justify-content-end">
                        {bankPartners.length > 1 &&
                          <Tooltip title="Delete" arrow>
                            <DeleteIcon onClick={() => removebankPartners(index)} style={{ color: "red", cursor: "pointer" }} />
                          </Tooltip>
                        }
                      </div>
                    </div>
                  ))}
                  <div className="form-row  mb-2">
                    <Grid className="d-flex justify-content-between">
                      <Tooltip title="Add" arrow>
                        <Button
                          className="button "
                          variant="outlined"
                          disableElevation
                          startIcon={<Add />}
                          onClick={() =>
                            appendbankPartners({
                              link: "",
                              target: "",
                              order: "",
                              text: "",
                            })
                          }
                        >
                          Add
                        </Button>
                      </Tooltip>
                    </Grid>
                  </div>
                </div>
                <hr />
              </Col>
              <Col lg={6}>
                <div className="text-success fw-bold mb-3 mt-3 buttons rounded-2" style={{ cursor: "pointer" }} onClick={() => toggleColumn('quick_links')}>
                  Update Quick Links <StarRateIcon />  {columnVisibility.quick_links ? <span><ExpandLessIcon /></span> : <span><ExpandMoreIcon /></span>}
                </div>
                <div style={{ display: columnVisibility.quick_links ? 'block' : 'none' }}>
                  {quickLinks.map((item, index) => (
                    <div key={item.id} className="form-row ">
                      <div className="column">
                        <Controller
                          name={`quick_links[${index}].text`}
                          control={control}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              label="Enter Text"
                              className={`form-control mb-2 ${errors.quick_links &&
                                errors?.quick_links[index]?.text
                                ? "error"
                                : ""
                                }`}
                            />
                          )}
                        />
                      </div>

                      <div className="column">
                        <Controller
                          name={`quick_links[${index}].link`}
                          control={control}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              label="Enter Link"
                              className={`form-control mb-2 ${errors.quick_links &&
                                errors?.quick_links[index]?.link
                                ? "error"
                                : ""
                                }`}
                            />
                          )}
                        />
                      </div>
                      <div className="d-flex gap-3">
                        <Controller
                          name={`quick_links[${index}].target`}
                          control={control}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              label="Enter Target"
                              select
                              className={`form-control mb-2 ${errors.quick_links &&
                                errors?.quick_links[index]?.target
                                ? "error"
                                : ""
                                }`}
                            >
                              <MenuItem value="_self">_self</MenuItem>
                              <MenuItem value="_blank">_blank</MenuItem>
                            </TextField>
                          )}
                        />
                        <Controller
                          name={`quick_links[${index}].order`}
                          control={control}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              select
                              label="Enter Order"
                              className={`form-control mb-2 ${errors.quick_links &&
                                errors?.quick_links[index]?.order
                                ? "error"
                                : ""
                                }`}
                            >
                              {[...Array(15).keys()].map((number) => (
                                <MenuItem
                                  key={number + 1}
                                  value={(number + 1).toString()}
                                >
                                  {number + 1}
                                </MenuItem>
                              ))}
                            </TextField>
                          )}
                        />
                      </div>
                      <div className="column d-flex justify-content-end">
                        {quickLinks.length > 1 &&
                          <Tooltip title="Delete" arrow>
                            <DeleteIcon onClick={() => removequickLinks(index)} style={{ color: "red", cursor: "pointer" }} />
                          </Tooltip>
                        }
                      </div>
                    </div>
                  ))}
                  <div className="form-row  mb-2">
                    <Grid className="d-flex justify-content-between">
                      <Tooltip title="Add" arrow>
                        <Button
                          className="button "
                          variant="outlined"
                          disableElevation
                          startIcon={<Add />}
                          onClick={() =>
                            appendquickLinks({
                              link: "",
                              target: "",
                              order: "",
                              text: "",
                            })
                          }
                        >
                          Add
                        </Button>
                      </Tooltip>
                    </Grid>
                  </div>
                </div>
              </Col>
            </Row>

            <Row>
              <Col lg={6}>
                <div className="text-success fw-bold mb-3 buttons rounded-2" style={{ cursor: "pointer" }} onClick={() => toggleColumn('footer_images')}>
                  Update Footer Image <StarRateIcon /> {columnVisibility.footer_images ? <span><ExpandLessIcon /></span> : <span><ExpandMoreIcon /></span>}
                </div>
                <div style={{ display: columnVisibility.footer_images ? 'block' : 'none' }}>
                  {photoFields.map((item, index) => (
                    <div key={item.id} className="form-row ">
                      <div className="column">
                        <div className="d-flex justify-content-around mb-3 mt-2">
                          <Button
                            variant="contained"
                            component="label"
                            {...register(`footer_images[${index}].file`)}
                            onClick={() => clearErrors(`footer_images[${index}].file`)} // Clear errors for URL when file input is clicked
                          >
                            Upload Image
                            <input
                              type="file"
                              {...register(`footer_images[${index}].file`)}
                              hidden
                              onChange={(e) => handleImage(index, "footer_images", e)}
                              className={`form-control mb-2 ${errors.footer_images &&
                                errors?.footer_images[index]?.image
                                ? "error"
                                : ""
                                }`}
                            />
                          </Button>
                          {watch(`footer_images[${index}].image`) && (
                            <div className="image_div">
                              <img
                                src={watch(`footer_images[${index}].image`)}
                                alt=""
                                width={100}
                                height="auto"
                                className="rounded image bg-dark"
                              />
                            </div>
                          )}

                        </div>
                      </div>
                      <Controller
                        name={`footer_images[${index}].file`}
                        control={control}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            label="Enter Footer Images Url"
                            className={`form-control mb-2 ${errors.footer_images &&
                              errors?.footer_images[index]?.file
                              ? "error"
                              : ""
                              }`}
                            onChange={(e) => handleUrlChange(index, "footer_images", e)}
                          />
                        )}
                      />
                      <div className="column">
                        <Controller
                          name={`footer_images[${index}].link`}
                          control={control}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              label="Enter Link"
                              className={`form-control mb-2 ${errors.footer_images &&
                                errors?.footer_images[index]?.link
                                ? "error"
                                : ""
                                }`}
                            />
                          )}
                        />
                      </div>
                      <div className="d-flex gap-3">
                        <Controller
                          name={`footer_images[${index}].target`}
                          control={control}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              select
                              label="Enter Target"
                              className={`form-control mb-2 ${errors.footer_images &&
                                errors?.footer_images[index]?.target
                                ? "error"
                                : ""
                                }`}
                            >
                              <MenuItem value="_self">_self</MenuItem>
                              <MenuItem value="_blank">_blank</MenuItem>
                            </TextField>
                          )}
                        />
                        <Controller
                          name={`footer_images[${index}].order`}
                          control={control}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              select
                              label="Enter Order"
                              className={`form-control mb-2 ${errors.footer_images &&
                                errors?.footer_images[index]?.order
                                ? "error"
                                : ""
                                }`}
                            >
                              {[...Array(15).keys()].map((number) => (
                                <MenuItem
                                  key={number + 1}
                                  value={(number + 1).toString()}
                                >
                                  {number + 1}
                                </MenuItem>
                              ))}
                            </TextField>
                          )}
                        />
                      </div>

                      <div className="column">
                        <Controller
                          name={`footer_images[${index}].alt`}
                          control={control}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              label="Enter Alt"
                              className={`form-control mb-2 ${errors.footer_images &&
                                errors?.footer_images[index]?.alt
                                ? "error"
                                : ""
                                }`}
                            />
                          )}
                        />
                      </div>
                      <div className="column d-flex justify-content-end">
                        {photoFields.length > 1 &&
                          <Tooltip title="Delete" arrow>
                            <DeleteIcon onClick={() => removePhoto(index)} style={{ color: "red", cursor: "pointer" }} />
                          </Tooltip>
                        }
                      </div>

                    </div>
                  ))}
                  <div className="form-row mb-2">
                    <Grid className="d-flex justify-content-between">
                      <Tooltip title="Add" arrow>
                        <Button
                          className="button "
                          variant="outlined"
                          disableElevation
                          startIcon={<Add />}
                          onClick={() =>
                            appendPhoto({
                              file: null,
                              link: "",
                              target: "",
                              order: "",
                              alt: "",
                            })
                          }
                        >
                          Add
                        </Button>
                      </Tooltip>
                    </Grid>
                  </div>
                  <hr />
                </div>
              </Col>
              <Col lg={6}>
                <div className="column">
                  <TextField
                    type="text"
                    {...register(`copy_right`)}
                    className={`form-control mb-2 ${errors.copy_right ? "error" : ""
                      }`}
                    label="Enter Copy Right "
                  />
                </div>
              </Col>
            </Row>
            <Grid className="d-flex justify-content-between">
              <Toolbar className="p-0">
                <Button
                  // color="inherit"
                  className="button"
                  variant="contained"
                  disabled={activeStep === 0}
                  onClick={handleBack}
                  sx={{ mr: 1 }}
                >
                  Back
                </Button>
              </Toolbar>
              {isLoading ? (
                <Toolbar className="p-0">
                  <Button
                    className="button "
                    variant="contained"
                    disableElevation
                  // endIcon={<NavigateNextIcon />}
                  // type="submit"
                  >
                    Loading...
                    <CircularProgress color="success" size="1.7rem" />
                  </Button>
                </Toolbar>
              ) : (
                <Toolbar className="p-0">
                  <Button
                    className="button "
                    variant="contained"
                    disableElevation
                    // endIcon={<NavigateNextIcon />}
                    type="submit"
                  >
                    Update
                  </Button>
                </Toolbar>
              )}
            </Grid>
          </div>
        </form>
      </Paper>
    </Box>
  );
};

export default UpdateFooter;
